import { Flex, Typography, Card, ConfigProvider, Button } from 'antd';
import { ReactComponent as LastUpdatedBlackSvg } from '../../../assets/icons/last-updated-black.svg';
import { ReactComponent as LastUpdatedWhiteSvg } from '../../../assets/icons/last-updated-white.svg';
import Icon from '@ant-design/icons';
import { useTheme } from '../../../context/ThemeContext';
import React from 'react';
import { formatTime } from '../../../utilities/commonFunctions';
import { ReactComponent as Success } from '../../../assets/icons/successful.svg';
import { ReactComponent as Failure } from '../../../assets/icons/failure.svg';
import { ReactComponent as SendSvg } from '../../../assets/icons/send.svg';
import { BROADCAST_STATUS_KEYS, DARK } from '../../../utilities/constants';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const { Text } = Typography;

const BroadcastDayLogCard = ({ data, handleResendClick }) => {
  const { theme } = useTheme();

  const isWithinLastFiveMinutes = timestamp => {
    if (timestamp) {
      return dayjs().diff(dayjs(timestamp), 'minute') <= 5;
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            colorBgContainer: 'var(--broadcast_form-input-bg-color, #2e3033)',
            padding: 16,
            paddingLG: 16,
          },
        },
      }}
    >
      <Card
        variant="borderless"
        className="full-width broadcast-day-log"
        title={
          <Flex
            justify="space-between"
            style={{ padding: '12px 0px', width: '100%' }}
            gap={10}
            align="center"
            wrap={false}
          >
            <Text
              strong
              style={{
                flex: 1,
                minWidth: 0,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
            >
              {data?.device_id && data?.trip_id
                ? `${data?.device_id} | ${data?.trip_id}`
                : 'Recipients'}
            </Text>
            <Flex align="center" justify="end" style={{ marginLeft: 'auto' }}>
              {data?.consolidatedStatus === BROADCAST_STATUS_KEYS.SUCCESS && (
                <Flex gap={8} align="center">
                  <Icon component={Success} className="status-icon" />
                  <Text style={{ fontWeight: 400 }}>Success</Text>
                </Flex>
              )}
              {data?.consolidatedStatus === BROADCAST_STATUS_KEYS.FAILED && (
                <Flex gap={8} align="center">
                  <Icon component={Failure} className="status-icon" />
                  <Text style={{ fontWeight: 400 }}>Failed</Text>
                </Flex>
              )}
              {data?.consolidatedStatus === BROADCAST_STATUS_KEYS.FAILED &&
                isWithinLastFiveMinutes(data?.createdTimestamp) && (
                  <Button
                    type="link"
                    onClick={() => handleResendClick(data)}
                    icon={<SendSvg />}
                  />
                )}
            </Flex>
          </Flex>
        }
      >
        <Flex gap={16} vertical>
          <Flex className="broadcast-status-time" gap={4}>
            <Icon
              component={
                theme === DARK ? LastUpdatedWhiteSvg : LastUpdatedBlackSvg
              }
            />
            <Text>{formatTime(data?.createdTimestamp)}</Text>
          </Flex>
          <Text>{data?.message}</Text>
        </Flex>
      </Card>
    </ConfigProvider>
  );
};

BroadcastDayLogCard.propTypes = {
  data: PropTypes.object,
  handleResendClick: PropTypes.func,
};

export default React.memo(BroadcastDayLogCard);
